import { createContext, useContext, useEffect, useState } from "react";

//Context for setting header title

export const HeaderTitleContext = createContext();

export const HeaderTitleProvider = ({ children }) => {
  const [title, setTitle] = useState(null);

  return (
    <HeaderTitleContext.Provider value={{ title, setTitle }}>
      {children}
    </HeaderTitleContext.Provider>
  );
};

export const usePageTitle = (title) => {
  const ctx = useContext(HeaderTitleContext);

  useEffect(() => {
    ctx.setTitle(title);
    return () => ctx.setTitle(null);
  }, [title, ctx.setTitle, ctx]);
};

export const useGetHeaderTitle = () => {
  const context = useContext(HeaderTitleContext);
  return context?.title;
};
